declare const __VERSION__: string;
declare const __URL_BACKEND__: string;
declare const __KEYCLOAK_REALM__: string;
declare const __KEYCLOAK_CLIENT_ID__: string;
declare const __KEYCLOAK_REDIRECT_URL__: string;
declare const __WS_URL__: string;
declare const __URL_SMENADC__: string;
declare const __DAY_SHIFT_INTERVAL__: string;
declare const __NIGHT_SHIFT_INTEVAL__: string;

const version = __VERSION__;
const backUrl = __URL_BACKEND__;
const keycloak = {
	realm: __KEYCLOAK_REALM__,
	clientId: __KEYCLOAK_CLIENT_ID__,
	redirectUrl: __KEYCLOAK_REDIRECT_URL__,
};
const wsUrl = __WS_URL__;
const smenaUrl = __URL_SMENADC__;
const dayShiftInterval = __DAY_SHIFT_INTERVAL__;
const nightShiftInterval = __NIGHT_SHIFT_INTEVAL__;

export const config = { version, backUrl, wsUrl, keycloak, smenaUrl, dayShiftInterval, nightShiftInterval };
